export const selectNotificationsMessage = ({ notifications }) =>
  notifications.notification || {};
